export default function (props: any) {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M13.027 9.14a.55.55 0 0 1 .536.535c0 1.787-1.289 3.218-2.862 3.218H3.3c-1.573 0-2.861-1.43-2.861-3.218a.55.55 0 0 1 .535-.536.55.55 0 0 1 .536.536c0 1.18.788 2.137 1.79 2.146H10.7c1.002 0 1.79-.967 1.79-2.146a.55.55 0 0 1 .536-.536zM7.054 1.123c.283 0 .519.22.537.503V7.71L8.7 6.599a.532.532 0 0 1 .75.751L7.411 9.389a.617.617 0 0 1-.787 0L4.657 7.35a.532.532 0 0 1 .75-.75l1.11 1.109V1.627a.538.538 0 0 1 .537-.503z"
                fill="#000"
                fillRule="nonzero"
            />
        </svg>
    );
}
